import React from 'react';

import Form from '../../Shared/UI/Form/components/Form';
import Field from '../../Shared/UI/Field/components/Field';
import Input from '../../Shared/UI/Input/components/Input';
import FormActions from '../../Shared/UI/FormActions/components/FormActions';
import Button from '../../Shared/UI/Button/components/Button';
import ResponsiveContainer from '../../Shared/UI/ResponsiveContainer/components/ResponsiveContainer';

import { useProfileState, useProfileActions } from './ProfileContext';

import { createUserCertification } from './restApi';

const NewUserCertificationForm = () => {
  const profileState = useProfileState();
  const { onResponse, onError, updateNewUserCertificationFormName, updateNewUserCertificationFormIssuingOrganization, updateNewUserCertificationFormDateObtained, updateNewUserCertificationFormExpirationDate, updateNewUserCertificationFormCredentialId, closeNewUserCertificationModal } = useProfileActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const handleSubmit = () => {
    createUserCertification({
      onResponse,
      onError,
      body: {
        authenticityToken,
        newUserCertificationForm: profileState?.newUserCertificationForm,
      },
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Field label="Name" id="name">
        <Input
          type="text"
          value={profileState?.newUserCertificationForm?.name || ''}
          onChange={(e) => {
            updateNewUserCertificationFormName(e.target.value);
          }}
        />
      </Field>

      <Field label="Issuing Organization" id="issuingOrganization">
        <Input
          type="text"
          value={profileState?.newUserCertificationForm?.issuingOrganization || ''}
          onChange={(e) => {
            updateNewUserCertificationFormIssuingOrganization(e.target.value);
          }}
        />
      </Field>

      <Field label="Date Obtained" id="dateObtained">
        <Input
          type="date"
          value={profileState?.newUserCertificationForm?.dateObtained || ''}
          onChange={(e) => {
            updateNewUserCertificationFormDateObtained(e.target.value);
          }}
        />
      </Field>

      <Field label="Expiration Date" id="expirationDate">
        <Input
          type="date"
          value={profileState?.newUserCertificationForm?.expirationDate || ''}
          onChange={(e) => {
            updateNewUserCertificationFormExpirationDate(e.target.value);
          }}
        />
      </Field>

      <Field label="Credential ID" id="credentialId">
        <Input
          type="text"
          value={profileState?.newUserCertificationForm?.credentialId || ''}
          onChange={(e) => {
            updateNewUserCertificationFormCredentialId(e.target.value);
          }}
        />
      </Field>

      <ResponsiveContainer name="form-actions">
        <FormActions>
          <Button
            variant="secondary"
            onClick={() => {
              closeNewUserCertificationModal();
            }}
          >
            Cancel
          </Button>
          <Button type="submit">
            Save Your Certification
          </Button>
        </FormActions>
      </ResponsiveContainer>
    </Form>
  );
};

export default NewUserCertificationForm;
